import type { ComponentProps } from "react";

import { cn } from "cn";

/**
 * Constrained content width (legacy `.app-container`).
 * Not baked into Layout — full-bleed pages (grids) and fixed chrome (BookingNavigation)
 * need to opt in.
 */
function AppContainer({ className, ...props }: ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "mx-auto w-full px-4 lg:max-w-4xl xl:max-w-6xl",
        className
      )}
      {...props}
    />
  );
}

export { AppContainer };
